import { createUseStyles } from 'react-jss'

const useIconRowStyles = createUseStyles({
  iconsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6.336px',
    fontSize: '0.97em',
    '& > *': {
      transition: 'transform 0.15s ease',
      '&:hover': {
        transform: 'scale(1.6)',
      },
    },
  },

  flagIcon: {
    fontSize: '0.75em',
  },
})

export default useIconRowStyles
